module.exports = __webpack_public_path__ + "img/git-icon.28af49b6.svg";